import { combineReducers } from 'redux';
import booking from './BookingReducer';

const rootReducer = combineReducers({
  booking,
});

export default rootReducer;
